<script>
  import Snackbar, { Actions, Label } from '@smui/snackbar';
  import Button from '@smui/button';
  export let handleClosed = () => {};
  export let label = 'Subscribe now!';
  export let snackbar;
</script>

<Snackbar
  variant="stacked"
  class="subscribe-snack"
  leading
  bind:this={snackbar}
  on:SMUISnackbar:closed={handleClosed}
  timeoutMs={10000}
>
  <Label>{label}</Label>
  <Actions>
    <Button color="primary" variant="raised" tag="a" href={'/profile/pledge'} class="u-mr-small">
      <Label>Subscribe Now</Label>
    </Button>
  </Actions>
</Snackbar>
